export * from './variant-a'
